// extracted by mini-css-extract-plugin
module.exports = {"stickyHeader":"DeviationsTable_stickyHeader_lA77O","q-table__top":"DeviationsTable_q-table__top_1T6hf","q-table__bottom":"DeviationsTable_q-table__bottom_2evJj"};